import {
  Container,
  Grid,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Box,
  CardActions,
  FormGroup,
  FormControlLabel,
  Switch
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'src/common/Loader';
import ConfirmationDialog from 'src/common/ConfirmationDialog';
import { setSuccessInfo, setErrorInfo } from 'src/redux/modalSlice';
import { getDriverDetails, updateDriver } from 'src/redux/driverSlice';
import { CONFIRMATION_MSG } from 'src/utils/constants';
import InfoField from 'src/common/InfoField';
import ROUTE from 'src/utils/routeConstants';
import { getStateName } from 'src/utils/getInitials';
import PasswordResetModal from 'src/common/PasswordResetModal';
import NewUser from './NewDriver';

function DriverDetails() {
  const { driverId } = useParams();
  const history = useHistory();
  const { loading, driverDetails } = useSelector((state) => state.drivers);
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassResetModal, setShowPassResetModal] = useState(false);

  useEffect(() => {
    dispatch(getDriverDetails(driverId)).unwrap();
  }, []);

  const updateDriverDetails = () => setOpenModal(true);

  const onModalClose = () => setShowConfirmModal(false);

  const onStatusChange = () => setShowConfirmModal(true);

  const resetUserPassword = () => setShowPassResetModal(true);
  const onPassResetModalClose = () => setShowPassResetModal(false);

  const updateStatus = async () => {
    setShowConfirmModal(false);
    setIsLoading(true);
    try {
      const values = { ...driverDetails, is_active: !driverDetails.is_active };
      await dispatch(updateDriver(values)).unwrap();
      setIsLoading(false);
      dispatch(
        setSuccessInfo({
          successMsg: 'driver status updated successfully!'
        })
      );
      // handle result here
    } catch (error) {
      console.log('error', error);
      // handle error here
      setIsLoading(false);
      dispatch(
        dispatch(setErrorInfo({ modalError: error.error_message }))
      );
    }
  };

  return (
    <Container maxWidth="lg">
      <NewUser
        open={openModal}
        initialValues={driverDetails}
        handleClose={() => setOpenModal(false)}
      />
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12}>
          {loading || isLoading ? (
            <Loader />
          ) : (
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: 'calc(100vh - 140px)'
              }}
            >
              <CardHeader
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 3,
                  bgcolor: 'background.paper',
                  borderBottom: '1px solid',
                  borderColor: 'divider'
                }}
                title="Driver Details"
                action={(
                  <Button variant="contained" onClick={() => history.replace(ROUTE.drivers)}>
                    <ArrowBackIosIcon fontSize="inherit" />
                    Back
                  </Button>
                )}
              />
              <Divider />
              <CardContent sx={{ flex: 1, overflowY: 'auto' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                  <InfoField name="User Name" value={`${driverDetails.first_name} ${driverDetails.last_name}`} />
                  <InfoField name="Site name" value={driverDetails.site_name} />
                </Grid>
                <Grid sx={{ display: 'flex', flexDirection: 'row', mt: 4 }}>
                  <InfoField name="Email" value={driverDetails.email} />
                  <InfoField name="Phone Number" value={driverDetails.mobile_num} />
                  <InfoField
                    name="Address"
                    value={`${driverDetails.city}, ${getStateName(driverDetails.state)}`}
                  />
                </Grid>
                <Grid sx={{ display: 'flex', flexDirection: 'row', mt: 4 }}>
                  <InfoField name="Vehicle Assigned" value={driverDetails.vehicle} />
                  <Box sx={{ width: '35%' }}>
                    <Typography color="textSecondary" variant="body1">
                      Status
                    </Typography>
                    <FormGroup>
                      <FormControlLabel
                        control={(
                          <Switch
                            checked={driverDetails.is_active}
                            value={driverDetails.is_active}
                            color={driverDetails.is_active ? 'success' : 'default'}
                          />
                        )}
                        onChange={onStatusChange}
                        label={driverDetails.is_active ? 'Active' : 'Inactive'}
                      />
                    </FormGroup>
                  </Box>
                </Grid>

              </CardContent>
              <CardActions
                sx={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 2,
                  bgcolor: 'background.paper',
                  borderTop: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <Button
                  sx={{ m: 2 }}
                  variant="contained"
                  color="secondary"
                  onClick={updateDriverDetails}
                >
                  Update Details
                </Button>
                <Button
                  sx={{ m: 2 }}
                  variant="contained"
                  color="warning"
                  onClick={resetUserPassword}
                >
                  Reset Password
                </Button>
              </CardActions>
            </Card>
          )}
        </Grid>
      </Grid>
      <PasswordResetModal
        open={showPassResetModal}
        userEmail={driverDetails?.email}
        onClose={onPassResetModalClose}
      />
      <ConfirmationDialog
        info={driverDetails.is_active ? CONFIRMATION_MSG.disableDriver : CONFIRMATION_MSG.enableDriver}
        open={showConfirmModal}
        disable={driverDetails.is_active}
        onClose={onModalClose}
        onSubmit={updateStatus}
      />
    </Container>
  );
}

export default DriverDetails;
